import {
  numberOnly,
  isEmail,
  isPhone,
  moreThanLength,
  lessThanLength,
  betweenLength,
} from '~components/common/forms/UniversalValidations.js'

export const InternCompanyFormBlueprint = [
  {
    key: 'department_ofs_id',
    type: 'select',
    div: 'auto',
    square_width: '250px',
    class_name: ['flex_row', 'head_column'],
    label: '系所名稱：',
  },
  /* 1 - input、textarea */
  {
    type: 'section_title',
    text: '一、實習工作概況',
  },
  {
    key: 'enterprise_name',
    type: 'input',
    div: 2,
    disabled: true,
    required: true,
    label: '公司名稱：',
    max_length: 500,
  },
  {
    key: 'company_role',
    type: 'input',
    div: 2,
    required: true,
    label: '職稱：',
    max_length: 500,
  },
  {
    key: 'contact_person',
    type: 'input',
    div: 3,
    required: true,
    label: '聯絡人：',
    max_length: 500,
  },
  {
    key: 'contact_tel',
    type: 'input',
    div: 3,
    required: true,
    label: '聯絡電話：',
    check (val) {
      if(!isPhone(val)) return '無效的聯絡電話';
    },
    max_length: 500,
  },
  {
    key: 'fax',
    type: 'input',
    div: 3,
    required: true,
    label: '傳真：',
    max_length: 500,
  },
  {
    key: 'work_content',
    type: 'textarea',
    div: 1,
    required: true,
    label: '工作內容：',
    placeholder: '請輸入工作內容',
    max_length: 500,
  },
  {
    key: 'work_requirment',
    type: 'textarea',
    div: 1,
    required: true,
    label: '需求條件或專長：',
    placeholder: '請輸入需求條件或專長',
    max_length: 500,
  },
  /* 1 - 輪班 */
  {
    key: 'shift_status',
    type: 'radio',
    div: 'auto',
    required: true,
    class_name: 'flex_row',
    label: '輪班：',
    options: ['是', '否'],
    values: [1, 0],
  },
  {
    type: 'outer',
    div: 'auto',
    class_name: 'flex_row',
    blocks: [
      {
        type: 'number',
        key: 'work_time',
        div: 'auto',
        class_name: ['flex_row', 'work_time_input'],
        required: true,
        decimal_place: 0,
        label: '工作',
        tail_label: '時',
        placeholder: '00',
      },
      {
        type: 'number',
        key: 'work_days',
        div: 'auto',
        class_name: ['flex_row', 'work_time_input'],
        required: true,
        decimal_place: 0,
        label: '，做',
        tail_label: '天',
        placeholder: '0',
      },
      {
        type: 'number',
        key: 'rest_days',
        div: 'auto',
        class_name: ['flex_row', 'work_time_input'],
        required: true,
        decimal_place: 0,
        label: '休',
        tail_label: '天',
        placeholder: '0',
      },
    ],
  },
  {
    type: 'br',
  },
  /* 1 - number */
  {
    key: 'department_id',
    type: 'select',
    div: 3,
    required: true,
    label: '系別：',
  },
  {
    key: 'salary',
    type: 'number',
    div: 3,
    required: true,
    label: '提供薪資額度：',
  },
  {
    type: 'br',
  },
  {
    key: 'work_hour',
    type: 'number',
    div: 3,
    required: true,
    label: '工作時間（每週時數）：',
  },
  {
    key: 'ot_weekly',
    type: 'number',
    div: 3,
    required: true,
    label: '加班時間（每週時數）：',
  },
  {
    key: 'ot_daily',
    type: 'number',
    div: 3,
    required: true,
    label: '加班時間（每日時數）：',
  },
  /* 1 - radio */
  {
    key: 'health_insurance',
    type: 'radio',
    div: 3,
    required: true,
    class_name: 'flex_row',
    label: '勞健保：',
    list_style: 'nowrap',
    options: ['是', '否'],
    values: [1, 0],
  },
  {
    key: 'labor_pension',
    type: 'radio',
    div: 3,
    required: true,
    class_name: 'flex_row',
    label: '提撥勞退基金：',
    list_style: 'nowrap',
    options: ['是', '否'],
    values: [1, 0],
  },
  {
    key: 'sign_contract',
    type: 'radio',
    div: 3,
    required: true,
    class_name: 'flex_row',
    label: '配合簽約：',
    list_style: 'nowrap',
    options: ['是', '否'],
    values: [1, 0],
  },
  {
    key: 'provide_meal',
    type: 'radio',
    div: 3,
    required: true,
    class_name: 'flex_row',
    label: '膳食：',
    list_style: 'nowrap',
    options: ['自理', '其他'],
    values: [1, 0],
  },
  {
    key: 'provide_stay',
    type: 'radio',
    div: 3,
    required: true,
    class_name: 'flex_row',
    label: '住宿：',
    list_style: 'nowrap',
    options: ['供宿', '自理'],
    values: [1, 0],
  },
  {
    type: 'hr',
  },
  /* 2 - 實習工作評估 */
  {
    type: 'section_title',
    text: '二、實習工作評估',
  },
  {
    key: 'mark_date',
    type: 'output_button',
    custom_type: 'date',
    div: 3,
    square_width: '150px',
    class_name: 'flex_row',
    icon: 'date',
    label: '評估時間：',
  },
  {
    key: 'check',
    type: 'radio_table',
    div: 1,
    required: true,
    items: ['1. 工作環境', '2. 工作安全', '3. 工作專業', '4. 體力負荷', '5. 培訓計畫', '6. 合作理念', '7. 整體總評'],
    options: ['極佳', '佳', '可', '不佳', '極不佳'],
    values: [5, 4, 3, 2, 1],
    change (val) {
      let sum = val.reduce((s, v) => s + (+v || 0), 0);
      return {
        check_mark: new String(sum || 0),
      };
    },
  },
  {
    key: 'check_mark',
    type: 'output',
    must_get_value: true,
    div: 'auto',
    square_width: '100px',
    class_name: 'flex_row',
    label: '評估總分（滿分35)：',
    default: '0',
  },
  {
    type: 'hr',
  },
  /* 3 - 實習機會 */
  {
    type: 'section_title',
    text: '三、實習機會',
    sub_text: '(可複選)',
  },
  {
    key: 'company_apply',
    type: 'onoff',
    div: 'auto',
    label: '廠商申請',
  },
  {
    key: 'teacher_apply',
    input_key: 'teacher_apply_name',
    type: 'input_onoff',
    max_length: 500,
    div: 'auto',
    checked_required: true,
    tail_label: '老師推介',
    square_width: '100px',
  },
  {
    key: 'student_apply',
    input_key: 'student_apply_name',
    type: 'input_onoff',
    max_length: 500,
    div: 'auto',
    checked_required: true,
    tail_label: '學生申請',
    square_width: '100px',
  },
  {
    key: 'other_apply',
    input_key: 'other_apply_name',
    type: 'input_onoff',
    max_length: 500,
    div: 'auto',
    checked_required: true,
    label: '其他',
    square_width: '100px',
  },
  {
    type: 'hr',
  },
  /* 4 - 補充說明 */
  {
    type: 'section_title',
    text: '四、補充說明',
    sub_text: '(請與實習機構確認務依實習合作契約期間提供實習機會，勿因公司營運因素而期中解約造成學生中斷實習之困擾。)',
  },
  {
    key: 'sup_explaination',
    type: 'textarea',
    required: true,
    default: '',
    max_length: 500,
  },
  {
    type: 'hr',
  },
  /* 5 - 評估結論 */
  {
    type: 'section_title',
    text: '五、評估結論',
    sub_text: '(評估結論如為「推薦實習」，請於正式簽約後，此表連同合約書影送就輔組備查。)',
  },
  {
    key: 'recommendation',
    type: 'radio',
    required: true,
    options: ['推薦實習', '不推薦實習'],
    values: [1, 0],
  },
  {
    key: 'dept_manager',
    type: 'input',
    div: 'auto',
    required: true,
    square_width: '200px',
    class_name: 'flex_row',
    label: '單位主管：',
    max_length: 500,
  },
];
